import type { GameDef } from './registry';
import { tacoSlap } from './tacoslap';
import { luOrLabu } from './luorlabu';
import { dropCode } from './dropcode';
import { courseOrCourse, whitmanFacts } from './swipe';

/** every game in the picker, in order. Add a game: one folder under src/games/, one line here. */
export const GAMES: GameDef[] = [tacoSlap, luOrLabu, dropCode, courseOrCourse, whitmanFacts];

export function findGame(id: string): GameDef | undefined {
  return GAMES.find((g) => g.id === id);
}
